import { simpleGet } from '#/client/custom';
import { IntegrationConfig } from '#/service/config/common.types';

const createScriptElement = (
  createElement: (
    tagName?: string
  ) => HTMLScriptElement = document.createElement.bind(document)
): HTMLScriptElement => createElement('script');

export const loadScript = ({
  src = '',
  appendToParent = true,
  parent = document.body,
  scriptElement = createScriptElement(),
}: {
  src?: string;
  appendToParent?: boolean;
  parent?: HTMLElement;
  scriptElement?: HTMLScriptElement;
}): Promise<HTMLScriptElement> => {
  return new Promise((resolve, reject) => {
    scriptElement.onload = () => {
      resolve(scriptElement);
    };

    scriptElement.onerror = () => {
      reject(new Error(`Failed to load script: ${src}`));
    };

    scriptElement.src = src;

    if (appendToParent) {
      parent?.appendChild(scriptElement);
    }
  });
};

export const resolveTestIntegration = async (
  bundleId: string,
  integration: IntegrationConfig
): Promise<{ bundleId: string; integration: IntegrationConfig; testUrl?: string }> => {
  const integrationConfiguration = {
    bundleId,
    integration,
  };
  const searchParams = new URLSearchParams(window.location.search);

  const integrationVersion = searchParams.get('integrationVersion');

  if (!integrationVersion) {
    return Promise.resolve(integrationConfiguration);
  }

  const testUrl = `/static/plugins/integrations/pull-requests/${integrationVersion}/${bundleId}/web/latest/index.js`;

  return simpleGet(testUrl)
    .then(() => ({ testUrl, ...integrationConfiguration }))
    .catch(() => integrationConfiguration);
};
